<script setup lang="ts">
  import { BackButton } from '@/shared/ui/components'

  import PositionCreate from '@/views/admin/positions/Create.vue'
  definePage({
    meta: {
      layout: 'admin',
    },
  })
</script>

<template>
  <div class="head">
    <div class="flex items-center gap-4">
      <BackButton
        :route="{
          name: '/admin/positions/',
        }"
        type="rounded"
      />
      <h2 class="text-2xl font-bold">{{ $t('admin_positions_new_title') }}</h2>
    </div>
  </div>
  <div class="content mt-4">
    <PositionCreate />
  </div>
</template>
